import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/rocola.it/rocola.it/node_modules/next/dist/client/app-dir/link.js");
